var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['event-status-pill', `event-status-pill--${_vm.status}`]},[_vm._v(_vm._s(_vm.langJson(_vm.label)))])
}
var staticRenderFns = []

export { render, staticRenderFns }